// Mock data for Arnab Sarkar Web Design Services

export const heroData = {
  headline: "Crafting Digital Experiences That Convert.",
  subheadline: "Professional Web Design Services by Arnab Sarkar. From static showcases to full-scale enterprise solutions.",
  ctaText: "View Packages"
};

export const pricingPlans = [
  {
    id: "basic",
    name: "THE LAUNCHPAD",
    tier: "Basic",
    price: 499,
    idealFor: "Personal portfolios, landing pages, and small businesses.",
    delivery: "Rapid 4-Day Delivery",
    isPopular: false,
    note: "Informational architecture (Frontend only).",
    features: [
      "Fully Responsive Static Design",
      "Essential Pages (Home, About, Services, Contact)",
      "Interactive Location Map & Contact Forms",
      "Smooth UI Animations",
      "Premium Hosting Setup Included"
    ]
  },
  {
    id: "standard",
    name: "THE PROFESSIONAL",
    tier: "Standard",
    price: 899,
    idealFor: "Growing businesses needing content control.",
    delivery: "1-Week Expedited Delivery",
    isPopular: true,
    note: null,
    includesFrom: "Basic",
    features: [
      "Secure User Login & Authentication",
      "Admin Dashboard & Role Management",
      "Dynamic Content Management System (CMS)",
      "Owner-editable Text & Images (Backend integration)",
      "Database Setup"
    ]
  },
  {
    id: "premium",
    name: "THE ENTERPRISE",
    tier: "Premium",
    price: 1299,
    idealFor: "Service-based businesses and e-commerce.",
    delivery: "~4 Weeks Comprehensive Build",
    isPopular: false,
    note: null,
    includesFrom: "Standard",
    features: [
      "Full Appointment Booking & Scheduling System",
      "Seat/Table Reservation Logic",
      "Secure Payment Gateway Integration (Stripe/PayPal)",
      "Transaction Email Notifications",
      "Priority Support Period"
    ]
  }
];

export const whyChooseData = [
  {
    id: 1,
    title: "Performance First",
    description: "Lightning-fast load times optimized for search engines and user experience.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Mobile Optimized",
    description: "Pixel-perfect responsive design that looks stunning on all devices.",
    icon: "Smartphone"
  },
  {
    id: 3,
    title: "Scalable Code",
    description: "Clean, maintainable architecture built to grow with your business.",
    icon: "Code2"
  }
];

export const footerData = {
  copyright: "© 2026 Arnab Sarkar Web Solutions",
  socialLinks: []
};

export const contactInfo = {
  email: "arnabsarkarprofessional@gmail.com",
  phone: "+91 9007731807",
  location: "Available Worldwide (Remote)"
};

export const contactFormFields = [
  { name: "name", label: "Your Name", type: "text", placeholder: "John Doe" },
  { name: "email", label: "Email Address", type: "email", placeholder: "john@example.com" },
  { name: "message", label: "Your Message", type: "textarea", placeholder: "Tell me about your project..." }
];
